module.exports = __webpack_public_path__ + "static/media/comdlg32_529.b7f56d33.ico";